import React from 'react'
import { BrowserRouter, Route, Switch } from 'react-router-dom'
import RouteProvider from '../RouteProvider'
import pages from '../../pages'
import RouteChangeHandler from '../Reactor/RouteChangeHandler'

const Router = () => (
  <BrowserRouter>
  <RouteChangeHandler/>
    <RouteProvider value={pages}>
      {(context) => (
        <Switch>
          {context.routes.map((route) => (
            <Route key={route} exact {...route} />
          ))}
        </Switch>
      )}
    </RouteProvider>
  </BrowserRouter>
)

export default Router
